// Google Tag Manager, shared with pfida.com, loaded by the app so consent can be set before it starts.

import { injectScript } from '../injectScript';

export const TAG_MANAGER_CONTAINER_ID = 'GTM-MFWFQTL';
export const TAG_MANAGER_SCRIPT_ID = 'gtm-script';

export type TagManagerWindow = Window & { dataLayer?: unknown[] };

/** Loads Tag Manager once. Never throws. */
export function loadTagManager(): boolean {
  try {
    if (document.getElementById(TAG_MANAGER_SCRIPT_ID)) {
      return false;
    }
    // Google's snippet: start event first, then the container script
    const win = window as TagManagerWindow;
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    injectScript(`https://www.googletagmanager.com/gtm.js?id=${TAG_MANAGER_CONTAINER_ID}`, { id: TAG_MANAGER_SCRIPT_ID });
    return true;
  } catch {
    return false;
  }
}
